module.exports = __webpack_public_path__ + "img/desinfektion.450c0e5.png";